angular.module('unica_invitation_room.invitation_room_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// ROOM INVITATION LIST
		.state('app.hospitality.invitation_room_list', {
			url: '/invitation-room-list/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-room/templates/list.html',
					controller: 'InvitationRoomListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Assegnazioni Stanze',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
				}
			}
		})

		// ROOM INVITATION CREATE
		.state('app.hospitality.invitation_room_assign', {
			url: '/invitation-room-assign/:event_id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-room/templates/assign.html',
					controller: 'InvitationRoomAssignController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Assegna Stanza',
				parent: function($scope) {
					return 'app.hospitality.invitation_room_list({event_id:' + $scope.event_id + '})';
				}
			}
		})

		// ROOM INVITATION EDIT
		.state('app.hospitality.invitation_room_edit', {
			url: '/invitation-room-edit/:event_id/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/invitation-room/templates/edit.html',
					controller: 'InvitationRoomEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Assegnazione Stanza',
				parent: function($scope) {
					return 'app.hospitality.invitation_room_list({event_id:' + $scope.event_id + '})';
				}
			}
		});




});

